import { render, staticRenderFns } from "./NewsLetterSubscription.vue?vue&type=template&id=36f8411e"
import script from "./NewsLetterSubscription.vue?vue&type=script&lang=js"
export * from "./NewsLetterSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports